import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'self_belief'

export default function SelfBeliefPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you believe you can become a regular dream journaler?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.selfBelief.heading')}
      buttons={[
        {
          text: `✨ ${t('pages.onboarding.selfBelief.options.absolutely')}`,
          value: 'Absolutely - I am ready',
          subtext: t('pages.onboarding.selfBelief.subtexts.absolutely'),
        },
        {
          text: `🌱 ${t('pages.onboarding.selfBelief.options.growing')}`,
          value: 'I am starting to believe',
          subtext: t('pages.onboarding.selfBelief.subtexts.growing'),
        },
        {
          text: `🤞 ${t('pages.onboarding.selfBelief.options.hopeful')}`,
          value: 'Hopeful but uncertain',
          subtext: t('pages.onboarding.selfBelief.subtexts.hopeful'),
        },
        {
          text: `🌿 ${t('pages.onboarding.selfBelief.options.needHelp')}`,
          value: 'I need guidance to get there',
          subtext: t('pages.onboarding.selfBelief.subtexts.needHelp'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
